export default __webpack_public_path__ + "static/media/partlycloudy.c5c1000b.svg";